const FORM_FIELDS = {
  PRODUCT_TITLE: 'Product Title',
  PRODUCT_URL: 'Product URL',
  IMAGE_URL: 'Image URL',
  PRODUCT_SUBTITLE: 'Product Subtitle',
  BUY_BUTTON_TEXT: 'Buy Button Text',
  RIBBON_TEXT: 'Ribbon Text',
  PRODUCT_DESCRIPTION: 'Product Description',
  CTA_SUBTITLE: 'CTA Subtitle',
  PRODUCT_BODY: 'Product Body',
};

export default FORM_FIELDS;
